import React, { useMemo } from 'react';
import { useGetWhatsappGroupsQuery } from 'src/redux/services/centralApi';
import { CopyOutlined, PlusOutlined, ReloadOutlined } from '@ant-design/icons';
import { Button, Flex, Space, Table, Typography, TableColumnsType } from 'antd';
import DashboardTemplate from 'src/templates/DashboardTemplate';
import DeleteGroup from 'src/pages/communication/whatsapp/ListWhatsappGroupsPage/components/DeleteGroup';
import EditGroup from 'src/pages/communication/whatsapp/ListWhatsappGroupsPage/components/EditGroup';
import { useNavigate } from 'react-router-dom';
import { WhatsappGroup } from 'src/interfaces/entities/whatsappGroup';
import { toast } from 'react-toastify';

export default function ListWhatsappGroupsPage() {
	const navigate = useNavigate();

	const {
		data: wppGroupsData,
		isLoading: isLoadingWppGroups,
		isFetching: isFetchingWppGroups,
		refetch: refetchWppGroups,
	} = useGetWhatsappGroupsQuery();

	const handleCopyLink = async (link?: string) => {
		if (!link) {
			toast.info('Este grupo não possui link de convite.', {
				autoClose: 2000,
			});
			return;
		}

		try {
			await navigator.clipboard.writeText(link);
			toast.success('Link de convite copiado para a área de transferência!', {
				autoClose: 2000,
			});
		} catch {
			toast.error('Erro ao copiar o link de convite!', { autoClose: 2000, });
		}
	};

	const columns = useMemo<TableColumnsType<WhatsappGroup>>(
		() => [
			{
				dataIndex: 'name',
				title: 'Nome',
				key: 'name',
			},
			{
				title: 'Link de convite',
				key: 'invitationLink',
				render: (_, record) => (
					<Flex align="center" gap={8}>
						<Typography.Paragraph
							title={record.invitationLink}
							style={{ maxWidth: 280, margin: 0, }}
							ellipsis
						>
							{record.invitationLink?.length
								? record.invitationLink
								: 'Sem link'}
						</Typography.Paragraph>
						<Button
							type="text"
							icon={<CopyOutlined />}
							disabled={!record.invitationLink}
							onClick={() => handleCopyLink(record.invitationLink)}
						/>
					</Flex>
				),
			},
			{
				title: 'Ações',
				key: 'actions',
				render: (_, record) => (
					<Space>
						<DeleteGroup row={record} />
						<EditGroup row={record} />
					</Space>
				),
			},
		],
		[]
	);

	return (
		<DashboardTemplate pageTitle="Listar grupos de Whatsapp">
			<Flex style={{ padding: 5, marginBottom: 8, }} gap={8} justify="end">
				<Button
					type="default"
					onClick={() => navigate('/comunicacao/whatsapp/grupos/adicionar')}
					icon={<PlusOutlined />}
				>
Adicionar
				</Button>
				<Button
					type="default"
					onClick={refetchWppGroups}
					icon={<ReloadOutlined />}
				/>
			</Flex>
			<Table<WhatsappGroup>
				columns={columns}
				dataSource={wppGroupsData ?? []}
				rowKey="groupId"
				loading={isLoadingWppGroups || isFetchingWppGroups}
				size="small"
			/>
		</DashboardTemplate>
	);
}
